<template>
  <div class="attendee-accom-section">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'accomControl'" key="create-loading" class="w-100" />
      <el-row v-else key="content-loading" class="w-100 accom-details-section">
        <template v-if="accoms.length > 0">
          <div class="accom-item" v-for="(accom, accomIndex) in accomsList" :key="accom.id + accomIndex">
            <div class="container">
              <div class="accom-item-wrapper">
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeAccom.nameSurname") }}</span>
                <span>
                  <b>{{ accom.questions.find(x => x.type == 1000).answer }}</b>
                  {{ accom.questions.find(x => x.type == 10001).answer }}
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeAccom.price") }}</span>
                <span>
                  <b>{{ accom.price }}</b>
                  {{ getEnumsDisplay("Currency", accom.currency) }}
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeAccom.registrationDate") }}</span>
                <span>
                  <b>{{ $moment(accom.createDate).format("DD MMMM YYYY, dddd HH:mm") }}</b>
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeAccom.linkedPayment") }}</span>
                <span>
                  <strong v-if="accom.paymentId != null">#{{ accom.paymentId }}</strong>
                  <strong v-else>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeAccom.noAffiliatePayments") }}</strong>
                </span>
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeAccom.confirmationStatus") }}</span>
                <el-dropdown placement="bottom-start">
                  <span
                    class="status"
                    :class="{
                      pending: accom.status == 0,
                      'payment-awaiting': accom.status == 1,
                      rejected: accom.status == 3,
                      confirmed: accom.status == 2
                    }"
                  >
                    <i
                      :class="{
                        'fas fa-clock': accom.status == 0,
                        'fas fa-credit-card': accom.status == 1,
                        'fas fa-check-circle': accom.status == 2,
                        'fas fa-times-circle': accom.status == 3
                      }"
                    ></i>
                    {{ getEnumsDisplay("ParticipantAccompayingPersonStatus", accom.status) }}
                  </span>

                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="status-pending-approve" v-if="accom.status != 2" @click.native="changeAccompayingPersonStatus(accom.id, 2)">
                      <i class="fas fa-check"></i>
                      {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeAccom.confirm") }}
                    </el-dropdown-item>
                    <el-dropdown-item class="status-pending-reject" v-if="accom.status != 3" @click.native="changeAccompayingPersonStatus(accom.id, 3)">
                      <i class="fas fa-times"></i>
                      {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeAccom.reject") }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div class="attendee-accom-edit">
                  <el-tooltip class="item" effect="dark" :content="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.seeDetails')" placement="top-start">
                    <el-button size="small" icon="fas fa-search" :loading="loading == 'accom-question-loading-' + accom.id" circle @click="openQuestion(accom)"></el-button>
                  </el-tooltip>
                  <!-- <el-tooltip class="item" effect="dark" :content="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.edit')" placement="top-start">
                  <el-button type="success" size="small" icon="fas fa-pen" circle></el-button>
                </el-tooltip> -->
                  <!-- <el-tooltip class="item" effect="dark" :content="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.delete')" placement="top-start">
                  <el-popconfirm :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteSure')" @confirm="alert()" :cancel-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.cancel')" :confirm-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteYes')" icon-color="red">
                    <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
                  </el-popconfirm>
                </el-tooltip> -->
                </div>
              </div>
            </div>
            <transition name="el-fade-in" mode="out-in">
              <div class="accom-registration-section" v-if="accom.showQuestion" :key="'accom-question-' + accom.id">
                <div class="accom-registration-item" v-for="question in accom.questions" :key="'accomquestion-list-item-' + question.id">
                  <span>{{ getQuestionOne(question, accom.id) != null ? getQuestionOne(question, accom.id).title : "Soru silinmiştir." }}</span>
                  <QuestionItem :question="getQuestionOne(question, accom.id)" />
                </div>
              </div>
            </transition>
          </div>
        </template>
        <el-alert v-else type="info" :show-icon="true" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.noAttendee')" :closable="false"></el-alert>
      </el-row>
    </transition>

    <!-- <div class="accom-item">
      <div class="accom-item-wrapper">
        <span>İsim soyisim</span>
        <span><b>Mustafa Özkan</b> Taştan</span>
        <span>Fiyat</span>
        <span><b>9.000,00</b> TRY</span>
        <span>Kayıt tarihi</span>
        <span><b>11 May 2022, 17:07</b></span>
        <span>Bağlı ödeme</span>
        <span><strong>#V8JJ167L2Z</strong></span>
        <span>Onay durumu</span>
        <el-dropdown placement="bottom-start">
          <span class="status payment-awaiting"><i class="fas fa-credit-card"></i>Ödeme bekliyor</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="status-pending-approve"><i class="fas fa-check"></i> Onayla</el-dropdown-item>
            <el-dropdown-item class="status-pending-reject"><i class="fas fa-times"></i> Reddet</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="attendee-accom-edit">
          <el-tooltip class="item" effect="dark" content="Kayıt detaylarını gör" placement="top-start">
            <el-button size="small" icon="fas fa-search" circle @click="showAccomDetails = !showAccomDetails"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.edit')" placement="top-start">
            <el-button type="success" size="small" icon="fas fa-pen" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
            <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
              <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
            </el-popconfirm>
          </el-tooltip>
        </div>
      </div>
      <div class="accom-registration-section" v-if="showAccomDetails">
        <div class="accom-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
      </div>
    </div>

    <div class="accom-item">
      <div class="accom-item-wrapper">
        <span>İsim soyisim</span>
        <span><b>Mustafa Özkan</b> Taştan</span>
        <span>Fiyat</span>
        <span><b>9.000,00</b> TRY</span>
        <span>Kayıt tarihi</span>
        <span><b>11 May 2022, 17:07</b></span>
        <span>Bağlı ödeme</span>
        <span><strong>#V8JJ167L2Z</strong></span>
        <span>Onay durumu</span>
        <el-dropdown placement="bottom-start">
          <span class="status confirmed"><i class="fas fa-check-circle"></i>Onaylandı</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="status-pending-approve"><i class="fas fa-check"></i> Onayla</el-dropdown-item>
            <el-dropdown-item class="status-pending-reject"><i class="fas fa-times"></i> Reddet</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="attendee-accom-edit">
          <el-tooltip class="item" effect="dark" content="Kayıt detaylarını gör" placement="top-start">
            <el-button size="small" icon="fas fa-search" circle @click="showAccomDetails = !showAccomDetails"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.edit')" placement="top-start">
            <el-button type="success" size="small" icon="fas fa-pen" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
            <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
              <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
            </el-popconfirm>
          </el-tooltip>
        </div>
      </div>
      <div class="accom-registration-section" v-if="showAccomDetails">
        <div class="accom-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
      </div>
    </div>

    <div class="accom-item">
      <div class="accom-item-wrapper">
        <span>İsim soyisim</span>
        <span><b>Mustafa Özkan</b> Taştan</span>
        <span>Fiyat</span>
        <span><b>9.000,00</b> TRY</span>
        <span>Kayıt tarihi</span>
        <span><b>11 May 2022, 17:07</b></span>
        <span>Bağlı ödeme</span>
        <span><strong>#V8JJ167L2Z</strong></span>
        <span>Onay durumu</span>
        <el-dropdown placement="bottom-start">
          <span class="status rejected"><i class="fas fa-times-circle"></i>Reddedildi</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="status-pending-approve"><i class="fas fa-check"></i> Onayla</el-dropdown-item>
            <el-dropdown-item class="status-pending-reject"><i class="fas fa-times"></i> Reddet</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="attendee-accom-edit">
          <el-tooltip class="item" effect="dark" content="Kayıt detaylarını gör" placement="top-start">
            <el-button size="small" icon="fas fa-search" circle @click="showAccomDetails = !showAccomDetails"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.edit')" placement="top-start">
            <el-button type="success" size="small" icon="fas fa-pen" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
            <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
              <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
            </el-popconfirm>
          </el-tooltip>
        </div>
      </div>
      <div class="accom-registration-section" v-if="showAccomDetails">
        <div class="accom-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="accom-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import participantInfo from "../../../store/participantInfo";
import QuestionItem from "../../register-form/Inputs/QuestionItem.vue";

export default {
  props: ["accoms", "participant"],
  components: {
    QuestionItem
  },
  data() {
    return {
      accomsList: [],
      loading: false,
      timeout: null,
      showAccomDetails: false
    };
  },
  async created() {
    this.loading = "accomControl";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (this.accoms != undefined && this.accoms != null) {
        this.accomsList = this.accoms.map(x => {
          return {
            ...x,
            questionList: [],
            showQuestion: false
          };
        });
      }
      this.loading = false;
    }, 500);
  },
  methods: {
    async openQuestion(item) {
      this.loading = "accom-question-loading-" + item.id;
      if (this.timeout != null) clearTimeout(this.timeout);
      if (item.showQuestion) {
        item.showQuestion = !item.showQuestion;
        this.loading = false;
      } else {
        this.timeout = setTimeout(async () => {
          var responsoQuestions = await this.$store.dispatch("getQuestionsObject", { id: this.participant.registrationFormId, type: 6 });
          item.questionList = responsoQuestions.data.data.items;
          item.showQuestion = !item.showQuestion;
          this.loading = false;
        }, 500);
      }
    },
    getQuestionOne(question, accomID) {
      var allQuestions = this.accomsList.find(x => x.id == accomID).questionList;
      var returned = allQuestions.find(x => x.registrationInputID == question.registrationInputID);
      if (returned == null) {
        return returned;
      }
      returned.answer = question.answer;
      returned.answers = question.answers;
      return returned;
    },
    async changeAccompayingPersonStatus(id, status) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          id: this.participant.id,
          accompayingPersonId: id,
          status: status,
          cancellationReason: null
        };
        if (status != 3) {
          var res = await this.$store.dispatch("changeAccompayingPersonStatus", payload);
          if (!res.data.alert.hasError) {
            this.$emit("refresh");
          }
        } else {
          if (this.$i18n.locale == "tr") {
            var reason = await this.$prompt("Lütfen bir sebep belirtin.", "Uyarı", {
              confirmButtonText: "Tamam",
              cancelButtonText: "Vazgeç",
              inputPattern: /(.|\s)*\S(.|\s)*/,
              inputErrorMessage: "Lütfen boş bırakmayınız."
            })
              .then(async ({ value }) => {
                payload.cancellationReason = value;
                var res = await this.$store.dispatch("changeAccompayingPersonStatus", payload);
                if (!res.data.alert.hasError) {
                  this.$emit("refresh");
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "İşlem iptal edildi."
                });
              });
          } else {
            var reason = await this.$prompt("Please provide a reason.", "Warning", {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              inputPattern: /(.|\s)*\S(.|\s)*/,
              inputErrorMessage: "Please fill in all fields."
            })
              .then(async ({ value }) => {
                payload.cancellationReason = value;
                var res = await this.$store.dispatch("changeAccompayingPersonStatus", payload);
                if (!res.data.alert.hasError) {
                  this.$emit("refresh");
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "The process has been cancelled."
                });
              });
          }
        }
      }, 500);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/AttendeeAccom.vue